import {
  Component,
  OnInit,
  OnDestroy,
  ViewChild,
  ElementRef,
} from '@angular/core';
import { SidenavService } from 'src/app/services/sidenav.service';
import { AppStateProvider } from 'src/app/services/app-state.provider';
import { Subscription } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { PlantService } from 'src/app/services/plant.service';

@Component({
  standalone: false,
  selector: 'app-print-qr-code',
  templateUrl: './print-qr-code.component.html',
  styleUrls: ['./print-qr-code.component.scss'],
})
export class PrintQrCodeComponent implements OnInit, OnDestroy {
  @ViewChild('printableDiv', { static: false }) printableDiv: ElementRef;

  private subscriptions = new Subscription();

  plantId: string = null;
  plantDetails: any;

  constructor(
    private sideNavService: SidenavService,
    private appStateSrv: AppStateProvider,
    private route: ActivatedRoute,
    private router: Router,
    private plantService: PlantService
  ) {
    localStorage.setItem('expandNavLand', 'true');
    // const routef = this.sideNavService.routingChunks({
    //   name: 'Landscaping and Vegetation',
    //   subNav: '0',
    //   subNavLink: '',
    // });
    // this.appStateSrv.setSideNavState(routef);
  }

  ngOnInit(): void {
    this.route.params.subscribe((params) => {
      this.plantId = params['id'];
    });
    console.log(this.plantId);

    this.getPlantDetails();
  }

  ngOnDestroy() {
    localStorage.removeItem('expandNavLand');
    this.subscriptions.unsubscribe();
  }

  print(divName: any): void {
    // const printContent = this.printableDiv.nativeElement.innerHTML;
    // const originalContent = document.body.innerHTML;

    // document.body.innerHTML = printContent;
    window.print();
    // document.body.innerHTML = originalContent;
  }

  // printDiv() {
  //   var divContents = document.getElementById("printableContent").innerHTML;
  //   var a = window.open('', '', 'height=500, width=500');
  //   a.document.write('<html>');
  //   a.document.write(divContents);
  //   a.document.write('</body></html>');
  //   a.document.close();
  //   a.print();
  // }

  onPrint(divName: any) {
    // console.log('Printing...');

    let element = document.getElementById(divName);
    let innerDiv = element.querySelector('div.pdf_box');

    if (innerDiv) {
      // console.log('Adding class to innerDiv');
      innerDiv.classList.add('mx-auto');
    }

    const printContents = element.innerHTML;
    const originalContents = document.body.innerHTML;
    document.body.innerHTML = printContents;

    window.onafterprint = function () {
      // console.log('After print...');
      document.body.innerHTML = originalContents;
      element = document.getElementById(divName);
      innerDiv = element.querySelector('div.pdf_box');
      if (innerDiv) {
        // console.log('Removing class from innerDiv');
        innerDiv.classList.remove('mx-auto');
      }
    };

    window.print();
    location.reload();
  }

  //api calls
  getPlantDetails() {
    this.plantService.getPlantDetail(this.plantId).subscribe((res) => {
      if (res.isValid === true) {
        this.plantDetails = res.data;
        console.log(this.plantDetails?.vegetationName);
      } else {
        this.plantDetails = [];
      }
    });
  }
}
